document.addEventListener('DOMContentLoaded', function () {
  const FREE_SHIPPING_THRESHOLD = window.themeSettings?.freeShippingThreshold || 50;

  function renderProgressBar(cart) {
    const container = document.getElementById('free-shipping-bar');
    if (!container) return;

    if (cart.items.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';

    const total = cart.total_price / 100;
    const remaining = (FREE_SHIPPING_THRESHOLD - total).toFixed(2);
    const unlocked = total >= FREE_SHIPPING_THRESHOLD;
    const progress = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);

    container.innerHTML = `
      <div>
        <span class="text unlocked-${unlocked}">${unlocked ? 'You’ve unlocked <strong>free shipping</strong>' : `Spend €${remaining} more for <strong>free shipping</strong>`}</span>
        <div class="bar-container">
        <div style="width: ${progress}%;">
        </div>
        </div>      
      </div>
    `;
  }

  function updateCartProgressBar() {
    fetch('/cart.js')
        .then(res => res.json())
        .then(renderProgressBar);
  }

  updateCartProgressBar();

  // ✅ Respond to UpCart quantity or cart changes
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(updateCartProgressBar, 1000);
  });

  // ✅ Respond to UpCart quantity or cart changes
  document.addEventListener('ajaxProduct:removed', function (evt) {
    if (evt.detail && evt.detail.cart) {
      renderProgressBar(evt.detail.cart);
    } else {
      updateCartProgressBar();
    }
  });

});